$(function () {
    if ($('.datePicker').length) {
        $('.datePicker').datetimepicker({
            format: 'DD.MM.YYYY',
            locale: 'cs'
        });
    }
});